import { useEffect } from 'react'

const appScheme = 'reggora://'
const MobileRouting = ({ location }) => {
  useEffect(() => {
    // location.search will pass down any query params to mobile
    window.location.href = `${appScheme}${location.search}`
  }, [])

  return null
}

export default MobileRouting
